import validationRules from '../../../utilities/validationRules';
import paymentConfirmationFormResources from './paymentConfirmationFormResources';

export const pinRequired = validationRules.required(
    paymentConfirmationFormResources.labelForPIN
);
export const pinNumeric = validationRules.numericOrEmpty(
    paymentConfirmationFormResources.labelForPIN
);